export default __webpack_public_path__ + "static/media/element_95.4170864d.avif";